import { useAuth } from "@/contexts/AuthContext";

const ADMIN_ALL = "__ADMIN_ALL__";

export function useWarehousePermissions() {
  const { user } = useAuth();
  const role = user?.role;
  const perms = new Set(user?.permissions || []);

  const isAdmin = role === "WAREHOUSE_ADMIN";

  // Admin has every permission; dispatcher only what's granted.
  const can = (key) => isAdmin || perms.has(key);
  const canAny = (...keys) => isAdmin || keys.some(k => perms.has(k));

  return { role, user, isAdmin, perms: Array.from(perms), can, canAny, ADMIN_ALL };
}
